/* eslint-disable no-nested-ternary */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { textCustomComparator } from '../../../contactType/components/tableHead';
import * as Styles from '../../../Maintain/client/Components/StyleConstant';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';

export const caseInsensitiveComparator = (valueA, valueB) => {
  let sortOrder = 1;
  const lowercaseA = valueA?.toLowerCase();
  const lowercaseB = valueB?.toLowerCase();
  if (lowercaseA === lowercaseB) {
    sortOrder = 0;
  } else if (lowercaseA < lowercaseB) {
    sortOrder = -1;
  }
  return sortOrder;
};
function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }
  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);
  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
}
function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}

const comparatorQtr = (a, b) => {
  const splittedQtrA = a?.split('Q');
  const splittedQtrB = b?.split('Q');
  if (splittedQtrA?.length > 0 || splittedQtrB?.length > 0) {
    return (
      splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0]
    );
  }
  return -1;
};
export const NDC_DRUG_TABLEHAD = [
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ndcComponent',
    maxWidth: Styles.Width_150,
    maxLength: Styles.Length_30,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    // maxWidth: Styles.Width_300,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'block',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    cellClass: 'frr-ellipsis-text frr-ellipsis-text-overlap',
    cellRenderer: 'nameRenderNdcDrugName',
    resizable: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
];

export const NDC_LABELER_DRUG_TABLEHAD = [
  {
    headerName: 'NDC',
    field: 'ndc',
    sort: 'asc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellRenderer: 'ndcLabelerComponent',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    lastColumn: true,
    cellRenderer: 'nameRenderNdcDrugName',
    cellClass: 'frr-ellipsis-text',
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: {},
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const LABELER_TABLEHAD = [
  {
    headerName: 'Labeler Code',
    field: 'labelerCode',
    minWidth: 160,
    editable: false,
    suppressMenu: false,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Labeler Name',
    field: 'labelerName',
    editable: false,
    suppressMenu: false,
    resizable: false,
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    comparator: caseInsensitiveComparator,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
];

export const CMS_UROA_TABLEHEAD = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    cellRenderer: 'ActionCellRender',
    minWidth: 120,
    maxLength: Styles.Length_255,
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    resizable: true,
    editable: false,
    suppressMenu: false,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
  },
  {
    headerName: 'Qtr/Year',
    field: 'cmsUroaIdVO.qtr',
    minWidth: 120,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    comparator: comparatorQtr,

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Load Date',
    field: 'cmsUroaIdVO.loadDt',
    cellRenderer: 'dateComponent',
    minWidth: 140,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    comparator: dateComparator,
  },
  {
    headerName: 'Record Type',
    field: 'cmsUroaIdVO.cmsUroaRecordTypeCd',
    minWidth: 160,
    resizable: false,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const CMS_COD_TABLEHEAD = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    cellRenderer: 'ActionCellRender',
    minWidth: 140,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    sortable: false,
    filter: false,
    showCheckboxIcon: true,
  },
  {
    headerName: 'CMS COD Status',
    field: 'cmsCodStatusCd',
    minWidth: 180,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Effective Qtr',
    field: 'cmsCodStatusIdVO.effectiveQtr',
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    comparator: comparatorQtr,

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Load Date',
    field: 'cmsCodStatusIdVO.loadDt',
    cellRenderer: 'dateComponent',
    minWidth: 160,
    resizable: false,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    comparator: dateComparator,
  },
];

export const CMS_DESI_TABLEHEAD = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    cellRenderer: 'ActionCellRender',
    resizable: false,
    minWidth: 100,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    editable: false, 
    suppressMenu: false,
  },
  {
    headerName: 'CMS DESI Code',
    field: 'cmsDesiCd',
    minWidth: 180,
    maxLength: Styles.Length_255,
    sort: 'asc',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    editable: false,
  },
  {
    headerName: 'Effective Qtr',
    field: 'cmsDesiIdVO.effectiveQtr',
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    comparator: comparatorQtr,
    editable: false, 
  },
  {
    headerName: 'Load Date',
    field: 'cmsDesiIdVO.loadDt',
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    comparator: (valA, valB) => {
      return Number(new Date(valA)) - Number(new Date(valB));
    },
    editable: false,
  },
];


export const DISPLAY_FAMILY_PLANNING_TABLEHEAD = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    cellRenderer: 'commentComponent',
    minWidth: 100,
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    // maxWidth: Styles.Width_200,
    resizable: true,
    editable: false,
    suppressMenu: false,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
  },
  {
    headerName: 'Rebate Program Code',
    field: 'rpcDrugFamilyPlanningIdVO.rebateProgramCd',
    minWidth: 180,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Family Planning Ind',
    field: 'familyPlanningInd',
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Start Date',
    field: 'rpcDrugFamilyPlanningIdVO.familyPlanningDt',
    cellRenderer: 'dateComponent',
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    sort: 'asc',
    comparator: dateComparator,

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const NDC_DETAILS_THERAPEUTIC_TABLEHEAD = [
  {
    headerName: 'Therapeutic Class',
    field: 'drugSpecTheraClassIdVO.specTheraClassCd',
    minWidth: 180,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Description',
    field: 'longDescr',
    cellRenderer: 'customDescription',
    minWidth: 180,
    resizable: false,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const NDC_DETAILS_ALTERNATE_THERAPEUTIC_TABLEHEAD = [
  {
    headerName: 'Therapeutic Class',
    field: 'altTc',
    minWidth: 180,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Description',
    field: 'longDescr',
    resizable: false,
    cellRenderer: 'customDescription',
    minWidth: 180,
    maxLength: Styles.Length_255,
    sort: 'asc',
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const CMS_DRUG_TABLEHEAD = [
  {
    headerName: 'Action',
    field: 'ccCommentsExist',
    cellRenderer: 'ActionCellRender',
    minWidth: 110,
    maxLength: Styles.Length_255,
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    resizable: true,
    editable: false,
    suppressMenu: false,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    exportOption: {
      enableValueFormatter: true,
    },
  },
  {
    headerName: 'Qtr/Year',
    field: 'cmsDrugId.qtr',
    minWidth: 120,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    sort: 'desc',
    sortingOrder: ['desc', 'asc'],
    comparator: comparatorQtr,

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Load Date',
    field: 'cmsDrugId.loadDt',
    minWidth: 140,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    comparator: dateComparator,
  },
  {
    headerName: 'Record Type',
    field: 'cmsDrugId.cmsUraRecordTypeCd',
    minWidth: 100,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const CMS_DRUG_URA_CORRECTION_TABLEHEAD = [
  {
    headerName: 'Qtr/Year',
    field: 'cmsDrugId.qtr',
    cellRenderer: 'textFieldComponent',
    minWidth: 160,
    maxLength: Styles.Length_255,
    filter: 'agTextColumnFilter',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Current URA',
    field: 'unitRebateAmt',
    cellRenderer: 'textFieldComponent',
    minWidth: 160,
    maxLength: Styles.Length_255,
    filter: 'agTextColumnFilter',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'New URA',
    field: 'newUnitRebateAmt',
    cellRenderer: 'textFieldComponent',
    minWidth: 160,
    maxLength: Styles.Length_255,
    filter: 'agTextColumnFilter',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'New Termination Dt',
    field: 'newTerminationDt',
    cellRenderer: 'terminationDtComponent',
    minWidth: 200,
    maxLength: Styles.Length_255,
    resizable: false,
    cellClass: 'ndcEndDate',
    filter: 'agTextColumnFilter',
    editable: false,
    suppressMenu: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const PRICE_TABLEHEAD = [
  {
    headerName: 'Target Qtr',
    field: 'priceId.targetQtr',
    minWidth: 160,
    editable:false,
    maxLength: Styles.Length_255,
    cellStyle: { display: 'flex', 'border-right-color': Styles.BorderColor },
    comparator: comparatorQtr,

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Start Date',
    field: 'priceId.startDt',
    cellRenderer: 'dateComponent',
    editable:false,
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: { display: 'flex', 'border-right-color': Styles.BorderColor },
    sort: 'asc',
    comparator: dateComparator,

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Date',
    field: 'endDt',
    cellRenderer: 'dateComponent',
    minWidth: 160,
    editable:false,
    maxLength: Styles.Length_255,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    comparator: dateComparator,
  },
  {
    headerName: 'Price',
    field: 'price',
    cellRenderer: 'priceComponent',
    editable:false,
    minWidth: 160,
    maxLength: Styles.Length_255,
    resizable: false,
    cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'end' },
    comparator: amountComparator,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
